/**
 * KillGoldFloatRules — who sees the yellow "+ x gold" combat float.
 *
 * The kill-gold float (`.fx-float-gold`, anchored on the killing minion) is
 * a REWARD indicator: it must only appear when the gold lands with the
 * VIEWER. The server's CombatKillGoldEvent carries `killerPlayerId` — the
 * gold's RECIPIENT (the player who killed the minion; for sourceless
 * deaths such as the sudden-death tick the killerInstanceId is the victim
 * itself but the recipient is still its enemy — see the centralized
 * death-gold rule). When the gold goes to the ENEMY (or the viewer is
 * spectating a pair they are not part of), no float is shown.
 */

/**
 * True when the local player should see the "+ x gold" float for a
 * killGold event.
 *
 * @param killerPlayerId The gold's recipient (CombatKillGoldEvent.killerPlayerId).
 * @param currentPlayerId The local player's ID (null before startApp).
 */
export function shouldShowKillGoldFloat(
  killerPlayerId: string | null | undefined,
  currentPlayerId: string | null | undefined
): boolean {
  return (
    typeof killerPlayerId === 'string' &&
    killerPlayerId.length > 0 &&
    typeof currentPlayerId === 'string' &&
    currentPlayerId.length > 0 &&
    killerPlayerId === currentPlayerId
  );
}
